import React from "react"

import StoryblokLink from "../../internal/storyblokLink/StoryblokLink"
import "./LinkCTAButton.scss"

const LinkCtaButton = ({ buttonProps, withClass }) => {

  if(buttonProps && buttonProps.url && buttonProps.url.fieldtype && !buttonProps.isModal) {
    return (
      <StoryblokLink text={buttonProps.text} withClass={`btn start-link ${buttonProps.cta_color ? buttonProps.cta_color : "black"} ${withClass ? withClass : ""}`} SBLinkData={buttonProps.url} />
    )
  }
  if(buttonProps && buttonProps.cta_link && buttonProps.cta_link.fieldtype && !buttonProps.isModal) {
    return (
      <StoryblokLink text={buttonProps.text} withClass={`btn start-link ${buttonProps.cta_color ? buttonProps.cta_color : "black"} ${withClass ? withClass : ""}`} SBLinkData={buttonProps.cta_link} />
    )
  }
  return (
    <div className="link-cta-button-wrapper">
      {/* Handles if the CTA button links to a modal or if it's going to a url */}
      {buttonProps.isModal ? (
        <button
          className={`btn start-link ${buttonProps.cta_color ? buttonProps.cta_color : "black"} ${withClass ? withClass : ""}`}
          href="#"
          datapropmodal={buttonProps.modalId}
        >
          {buttonProps.text}
        </button>
      ) : (
        <StoryblokLink text={buttonProps.text} withClass={`btn start-link ${buttonProps.cta_color ? buttonProps.cta_color : "black"} ${withClass ? withClass : ""}`} SBLinkData={buttonProps.url} />
      )}
      
    </div>
  )
}

export default LinkCtaButton
